import { API } from '../constants/api';
import httpClient from '../../common/api/httpClient';
import urlRoute from '../../common/service/urlRoute';
import ttlStorage from '../../common/service/ttlStorage';
import IOptionList from '../model/IOptionList';

const optionsCache = ttlStorage.create<IOptionList>();

const optionsApi = {
  list: (carId: string): Promise<IOptionList> => {
    if (optionsCache.has(carId)) {
      return new Promise(resolve => resolve(optionsCache.get(carId)));
    }

    return httpClient.get(urlRoute.createUrl(API.OPTIONS_PATH, { carId })).then(resp => {
      const list = resp.data as IOptionList;
      optionsCache.set(carId, list);
      return list;
    });
  },
};

export default optionsApi;
